import { createActionGroup, emptyProps, props } from '@ngrx/store';

import { AiProviderDto } from './models/ai-provider.model';

export const AiProvidersActions = createActionGroup({
  source: 'AI Providers',
  events: {
    Init: emptyProps(),
    'Get AI Providers': props<{ tenantUuid: string; subscriptionUuid: string }>(),
    'Load Success': props<{ aiProviders: readonly AiProviderDto[] }>(),
    'Load Failure': props<{ error: unknown }>(),
    Clear: emptyProps(),
  },
});
